import PageHeader from "@/components/PageHeader";
import Contact from "@/components/Contact";
import { useSeo } from "@/lib/seo";

export default function ContactPage() {
  useSeo({
    title: "Contact Us | Cool Runnings Cape Town",
    description:
      "Questions about tickets, parties or the track? Call, email or chat with the Cool Runnings team in Tygervalley, Cape Town.",
    keywords:
      "contact Cool Runnings, toboggan park contact Cape Town, Cool Runnings phone number, Cool Runnings email, book toboggan Cape Town",
    image: "/og/contact.jpg",
  });
  return (
    <>
      <PageHeader
        goodgirlTitle
        pageName="Contact"
        eyebrow="Talk to the front desk"
        title="CONTACT"
        subline="Events, school trips, platter orders or just a question — send it through and the front desk replies within one working day."
        image="/park-track.jpg"
      />
      <Contact />
    </>
  );
}
